import type { SetActivitySummaryStatsLoadingAction } from './typings'

export const setActivitySummaryStatsLoadingActionCreator = (
  payload: boolean,
): SetActivitySummaryStatsLoadingAction => ({
  type: 'activitySummary/setStatsLoading',
  payload,
})
